export const ACCOUNT_CHANGED = 'ACCOUNT_CHANGED';
export const NETWORK_CHANGED = 'NETWORK_CHANGED';

//# sourceMappingURL=Dapi.js.map
